var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: {
      id: "delete-component-modal",
      "modal-dialog-scrollable": false,
      "footer-class": "d-flex justify-content-between",
    },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [_vm._v("\n    " + _vm._s(_vm.message) + "\n  ")]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "div",
              [
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "secondary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("confirm-delete", false)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.actions.yesDelete")) +
                        "\n      "
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-button",
                  {
                    attrs: { size: "sm", variant: "primary" },
                    on: {
                      click: function ($event) {
                        return _vm.$emit("confirm-delete", true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("global.words.no")) +
                        "\n      "
                    ),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }